// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8b-3";
export var contentContainer = "_8b-0";
export var editorContainer = "_8b-1";
export var quillInputForm = "_8b-2";
export var zoneDivider = "_8b-4";